import { render, staticRenderFns } from "./AdminNewShipperModal.vue?vue&type=template&id=1e6dc6a8"
import script from "./AdminNewShipperModal.vue?vue&type=script&lang=js"
export * from "./AdminNewShipperModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e6dc6a8')) {
      api.createRecord('1e6dc6a8', component.options)
    } else {
      api.reload('1e6dc6a8', component.options)
    }
    module.hot.accept("./AdminNewShipperModal.vue?vue&type=template&id=1e6dc6a8", function () {
      api.rerender('1e6dc6a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminNewShipperModal.vue"
export default component.exports